module.exports ={
    template: {
        demo:'Template',
        toolsTip: [
            {
                label:'Select',
                iconUrl:'/static/images/tool-select.png',
                type:'select'
            },{
                label:'Text',
                iconUrl:'/static/images/tool-text.png',
                type: 'text'
            },{
                label:'Rectangle',
                iconUrl:'/static/images/tool-rect.png',
                type: 'rect'
            },{
                label:'Square',
                iconUrl:'/static/images/tool-square.png',
                type: 'square'
            },{
                label:'Ellipse',
                iconUrl:'/static/images/tool-ellipse.png',
                type: 'ellipse'
            },{
                label:'Circle',
                iconUrl:'/static/images/tool-circle.png',
                type: 'circle'
            },{
                label:'Line',
                iconUrl:'/static/images/tool-line.png',
                type: 'line'
            },{
                label:'Icon',
                iconUrl:'/static/images/tool-icon.png',
                type: 'icon'
            },{
                label:'Photo',
                iconUrl:'/static/images/tool-img.png',
                type: 'img'
            },{
                label:'Barcode',
                iconUrl:'/static/images/tool-barcode.png',
                type:'barcode'
            },{
                label:'QR code',
                iconUrl:'/static/images/tool-qrcode.png',
                type:'qrcode'
            },{
                label:'Delete',
                iconUrl:'/static/images/tool-del.png',
                type: 'del'
            }
        ],
        icons:[
            {label:"Mobile phone", prop:"icofont-iphone"},
            {label:"Credit card", prop:"icofont-credit-card"},
            {label:"Location", prop:"icofont-location-pin"},
            {label:"WeChat", prop:"icofont-wechat"},
            {label:"Alipay", prop:"icofont-brand-alipay"},
            {label:"EUR", prop:"icofont-euro"},
            {label:"Dollar", prop:"icofont-dollar"},
            {label:"RMB", prop:"icofont-yen"},
            {label:"GBP", prop:"icofont-pound"},
            {label:"Aircraft", prop:"icofont-airplane-alt"},
            {label:"Check circled", prop:"icofont-check-circled"},
            {label:"Check", prop:"icofont-check"},
            {label:"Recyclable", prop:"icofont-recycle"},
            {label:"Tick boxed", prop:"icofont-tick-boxed"},
            {label:"Warning", prop:"icofont-warning-alt"},
            {label:"Warning alt", prop:"icofont-warning"},
            {label:"WIFI", prop:"icofont-wifi"},
            {label:"WIFI alt", prop:"icofont-wifi-alt"},
            {label:"Bluetooth", prop:"icofont-bluetooth"},
            {label:"Not allowed", prop:"icofont-not-allowed"},
            {label:"No smoking", prop:"icofont-no-smoking"},
            {label:"Dial phone", prop:"icofont-ui-dial-phone"},
            {label:"Truck", prop:"icofont-truck-alt"},
            {label:"Bow", prop:"icofont-bow"},
            {label:"Support", prop:"icofont-support"},
            {label:"Laughing", prop:"icofont-laughing"},
            {label:"Smile", prop:"icofont-simple-smile"}                                  
        ],
        panelMsg:{
            screenSize: 'Screen：',
            screenColor: {
                red: 'Black White Red',
                yellow: 'Black White Yellow',
                black: 'Black White'
            },
            screenOrientation: 'Screen orientation：',
            screenOrientationOpt: ['Horizontal', 'Vertical'],
            screenWidth: 'Display width:',
            screenHeight: 'Display height:',
            dpi: 'Resolution：',
            x: 'x',
            y: 'y',
            w: 'w',
            h: 'h',
            cx: 'cx',
            cy: 'cy',
            r: 'r',
            rx: 'rx',
            ry: 'ry',
            x1: 'x1',
            y1: 'y1',
            x2: 'x2',
            y2: 'y2',
            text: 'text',
            // barWOpt:[95,190],
            barWOpt:[1, 2, 3, 4],
            fontFamily: 'Font family',
            fontSize: 'Font size',
            align: 'Alignment',
            anchor: [
                {
                    label: 'Align left',
                    iconUrl: '/static/images/panel-left.png',
                    prop:'start'
                },{
                    label: 'Align center',
                    iconUrl: '/static/images/panel-middle.png',
                    prop:'middle'
                },{
                    label: 'Align right',
                    iconUrl: '/static/images/panel-right.png',
                    prop:'end'
                }
            ],
            mutiAnchor: [
                {
                    label: 'Vertical equidistance',
                    iconUrl: '/static/images/vE.png',
                    disIconUrl: '/static/images/vE-disable.png',
                    prop:'vE',
                    eMethod: 'vEChange'
                },{
                    label: 'Horizontal equidistance',
                    iconUrl: '/static/images/hE.png',
                    disIconUrl: '/static/images/hE-disable.png',
                    prop:'hE',
                    eMethod: 'hEChange'
                },{
                    label: 'Align left',
                    iconUrl: '/static/images/hAlignL.png',
                    disIconUrl: '/static/images/hAlignL-disable.png',
                    prop:'hAlignL',
                    eMethod: 'hAlignLChange'
                },{
                    label: 'Align center',
                    iconUrl: '/static/images/hAlignM.png',
                    disIconUrl: '/static/images/hAlignM-disable.png',
                    prop:'hAlignM',
                    eMethod: 'hAlignMChange'
                },{
                    label: 'Align right',
                    iconUrl: '/static/images/hAlignR.png',
                    disIconUrl: '/static/images/hAlignR-disable.png',
                    prop:'hAlignR',
                    eMethod: 'hAlignRChange'
                },{
                    label: 'Align bottom',
                    iconUrl: '/static/images/vAlignB.png',
                    disIconUrl: '/static/images/vAlignB-disable.png',
                    prop:'vAlignB',
                    eMethod: 'vAlignBChange'
                },{
                    label: 'Align upper and lower',
                    iconUrl: '/static/images/vAlignM.png',
                    disIconUrl: '/static/images/vAlignM-disable.png',
                    prop:'vAlignM',
                    eMethod: 'vAlignMChange'
                },{
                    label: 'Align top',
                    iconUrl: '/static/images/vAlignT.png',
                    disIconUrl: '/static/images/vAlignT-disable.png',
                    prop:'vAlignT',
                    eMethod: 'vAlignTChange'
                }
            ],
            fontWeight: 'Font-weight',
            fontWeightOpt: [
                {
                    label: 'normal',
                    prop: 'normal'
                },{
                    label: 'bold',
                    prop: 'bold'
                }
            ],
            fontFamilyOpt: [
                {
                    label: 'WqyBitmapSong',
                    prop: 'WqyBitmapSong'
                },{
                    label: 'AlibabaPuhui',
                    prop: 'AlibabaPuhui'
                }, {
                    label: 'SourceHanSansJP',
                    prop: 'SourceHanSansJP'
                }
            ],
            textStyle: 'Text effect',
            needPre:'Display prefix',
            color: 'Fill',
            // optionalColors: [
            //     {
            //         label: 'red',
            //         value: '#9a2835'
            //     },{
            //         label: 'yellow',
            //         value: '#f1b804'
            //     },{
            //         label: 'black',
            //         value: '#000000'
            //     }
            // ],
            // optionalColors: {
            //     red: [{
            //         label: 'red',
            //         value: '#9a2835'
            //     },{
            //         label: 'black',
            //         value: '#000000'
            //     }],
            //     yellow: [{
            //         label: 'yellow',
            //         value: '#f1b804'
            //     },{
            //         label: 'black',
            //         value: '#000000'
            //     }],
            //     black: [{
            //         label: 'black',
            //         value: '#000000'
            //     }]
            // },
            optionalColors: {
                red: {
                    hexVal: '#9a2835',
                    label: 'red',
                    // colors: ['red', 'black']
                    colors: ['red', 'black', 'white']
                },
                yellow: {
                    hexVal: '#f1b804',
                    label: 'yellow',
                    // colors: ['yellow', 'black']
                    colors: ['yellow', 'black', 'white']
                },
                black: {
                    hexVal: '#000000',
                    label: 'black',
                    // colors: ['black']
                    colors: ['black', 'white']
                },
                white: {
                    hexVal: '#ffffff',
                    label: 'white',
                    colors: []
                }
            },
            brType: 'Barcode type',
            brTypeOpts: [
                {
                    label: 'ean13',
                    prop: 'ean13'
                },{
                    label: 'code128',
                    prop: 'code128'
                }
            ],
            bindData: 'Binding data',
            unBind: 'Unbind',
            bdPlaceholder: 'Please select',
            bindDataOpt:[
                {
                    label: 'Product number',
                    // sample: '编号:1101',
                    type:'text',
                    prop: 'proNo'
                },{
                    label: 'Product name',
                    // sample: '云里物里电子标签',
                    type:'text',
                    prop: 'name'
                },{
                    label: 'Product name abbreviation',
                    // sample: '电子标签',
                    type:'text',
                    prop: 'proAbbr'
                },{
                    label: 'Brand',
                    // sample: '云里物里',
                    type:'text',
                    prop: 'brand'
                },{
                    label: 'Price',
                    // sample: '￥68.00',
                    type:'text',
                    prop: 'price'
                },{
                    label: 'Place of origin',
                    // sample: '原产地:中国深圳',
                    type:'text',
                    prop: 'origin'
                },{
                    label: 'Grade',
                    // sample: '等级:A',
                    type:'text',
                    prop: 'rating'
                },{
                    label: 'Unit',
                    // sample: '单位:个',
                    type:'text',
                    prop: 'piece'
                },{
                    label: 'Specification',
                    // sample: '规格:2901',
                    type:'text',
                    prop: 'specification'
                },{
                    label: 'Supplier name',
                    // sample: '供货商:云里物里',
                    type:'text',
                    prop: 'supplierName'
                },{
                    label: 'Barcode text',
                    sample: '6666666666666',
                    type:'text',
                    prop: 'barcodeText'
                },{
                    label: 'QR code text',
                    sample: 'http://minewtech.com',
                    type:'text',
                    prop: 'qrcodeText'
                },{
                    label: 'Barcode',
                    type:'barcode',
                    prop: 'barcode'
                },{
                    label: 'QR code',
                    type:'qrcode',
                    prop: 'qrcode'
                }
            ],
            sampleContent:{
                "proNo":'1101',
                "name":'Minew ESL',
                "proAbbr": 'ESL',
                "brand": 'Minew',
                "price":'￥68.00',
                "origin":'Shenzhen, China',
                "rating":'A',
                "piece":'piece',
                "specification":'2901',
                "supplierName":'Minew',
                "barcode":'6666666666666',
                "barcodeText":'6666666666666',
                "qrcode": 'http://minewtech.com',
                "qrcodeText": 'http://minewtech.com',
                "unBind": 'Text Content',
                "imgUrl": '/static/images/logo_en.jpg',
                "text": 'text'
            },
            samplePrefix:{
                "proNo":'编号：',
                "name":'品名：',
                "proAbbr": '简称：',
                "brand": '品牌：',
                "price":'',
                "origin":'产地：',
                "rating":'等级：',
                "piece":'单位：',
                "specification":'规格：',
                "supplierName":'供货商：',
                "barcodeText":'',
                "qrcodeText": '',
                "unBind": 'prefix:'
            }
        },
        validMsg: {
            minFs: 'The font size must be more than 9',
            maxFs: 'The font size must be less than 1000',
            minW: 'The width must be more than 30',
            maxW: 'The width must be less than 1000',
            minH: 'The height must be more than 30',
            maxH: 'The height must be less than 1000',
            barMinH: 'The height must be more than 10',
            barMaxH: 'The height must be less than 1000',
            num: 'Please enter an integer',
            contentFormat: 'Enter a decimal number when using the price effect',
            uploadType:'Uploading images can only be in JPG or PNG format, and the file size should be within 500KB!',
            uploadSizeLt: 'Image size must be within {size}!',
            demoNameMsg: 'Please enter template name',
            demoNameFail: 'Failed to get, please re-enter',
            exist: 'The template already exist',
            zoomMsg: 'Please enter a percentage of 50%-200%',
            minOne: 'Please enter an integer greater than 0',
            minOneW: 'The width must be greater than 0',
            minOneH: 'The height must be greater than 0',
            charAndNum: 'Please enter numbers or letters'
        },
        editTip:{
            success: 'Template saved successfully',
            exist: 'The saved template does not exist or has been deleted',
            fail: 'Saving the template failed',
            permission: 'You don not have permission to modify the template',
            valid: 'Fail to save template, template data is invalid'
        },
        getTip: {
            exist: 'Edited template does not exist or has been deleted'
        },
        scaleTip: 'Tip: Zoom using scroll wheel with your mouse pointer on the template',
        cancel: 'Cancel',
        sure: 'Save',
        drawTip: {
            loadErr: 'Image failed to load',
            changeColorErr: 'Fill color failed',
            chooseImg: 'Please select an image to draw'
        },
        submiting: 'Saving...',
        editDemo: 'Edit template'
    }
}


// WEBPACK FOOTER //
// ./src/components/common/lang/en/template.js